import React from 'react';
import CloudFeederScorePanel from './CloudFeederScorePanel';

const MenuFeederScore = (props) => (
  <CloudFeederScorePanel {...props} mode="score" />
);

export default MenuFeederScore;
